import React from "react";

import { PageContainer } from "../../../../../../components/container/PageContainer";
import { CommAutoPolicyNotesList } from "./CommAutoPolicyNotesList";
import { useOutletContext } from "react-router-dom";
import { MODULE_NAMES } from "../../../../../../constants/enums";

export const CommAutoActivitiesTabs: React.FC = () => {
    const data = useOutletContext() as any;
  const customerId = data[0];
  const customerPolicyId = data[1];

  const moduleInformation = {
    moduleId: customerPolicyId,
    moduleName: MODULE_NAMES.COMMERCIAL_AUTO,
    subModuleName: MODULE_NAMES.COMMERCIAL_AUTO,
    refColumnName: "customer_policy_id",
  };

  return (
    <PageContainer
      title="Activities"
      description="this is innerpage"
    >
        <CommAutoPolicyNotesList
          customerId={customerId}
          customerPolicyId={customerPolicyId}
          moduleInformation={moduleInformation}
        />
    </PageContainer>
  );
};
